export default import.meta.ROLLUP_FILE_URL_X0J0VmbE9Y6eehvFaNyYWw;